import { contractTermsOptions } from "@/common/const/types/index.const";
import { ResponseFormElementsType } from "@/common/types/forms/FormFieldsStrategy.type";

const ipAddressResStrategy: ResponseFormElementsType[] = [
  {
    type: "text",
    attribute: "ipRange",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^(?!\s*$).+/,
    patternMessage: "IP Range must not be empty",
  },
  {
    type: "select",
    attribute: "contractTerm",
    required: true,
    options: [...contractTermsOptions],
    inputClassElement: "border-gray-surface bg-white",
  },
  {
    type: "text",
    attribute: "leadTeam",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^\d{1,3}$/,
    patternMessage: "Lead time must be a number (days)",
  },
];

export default ipAddressResStrategy;
